/**
 * External dependencies
 */
import { combineReducers } from 'redux';
import { reduce, get, omit } from 'lodash';

/**
 * Internal dependencies
 */
import { createReducer } from 'state/utils';
import {
    BARCODE_LOOKUP_PLANS_RECEIVE,
    BARCODE_LOOKUP_PLANS_REQUEST,
    BARCODE_LOOKUP_PLANS_REQUEST_SUCCESS,
    BARCODE_LOOKUP_PLANS_REQUEST_FAILURE,
    CURRENT_BARCODE_LOOKUP_RECEIVE,
} from 'state/action-types';

export const items = createReducer([], {
    [BARCODE_LOOKUP_PLANS_RECEIVE]: (state, action) => {
        return reduce(
            action.payload.items,
            (memo, subscription) => {
                const { id } = subscription;
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = subscription;
                return memo;
            },
            state,
        );
    },
});

export const requesting = createReducer(false, {
    [BARCODE_LOOKUP_PLANS_REQUEST]: () => true,
    [BARCODE_LOOKUP_PLANS_REQUEST_SUCCESS]: () => false,
    [BARCODE_LOOKUP_PLANS_REQUEST_FAILURE]: () => false,
});


export const error = createReducer(false, {
    [BARCODE_LOOKUP_PLANS_REQUEST]: () => false,
    [BARCODE_LOOKUP_PLANS_REQUEST_SUCCESS]: () => false,
    [BARCODE_LOOKUP_PLANS_REQUEST_FAILURE]: () => true,
});


export default combineReducers({
    items,
    requesting,
    error
});
